// Auto-generated by scripts/generate-sitemap.js. Do not edit by hand.
export const staticSiteRoutes = [
  "/",
  "/booking",
  "/book-tour",
  "/vehicle",
  "/services",
  "/faq",
  "/contactus",
  "/blogs",
  "/blogs/tirunelveli-cab-services-guide-2026",
  "/blogs/nava-kailayam-temple-tour-guide",
  "/blogs/tirunelveli-airport-transfer-guide",
  "/seo-pages",
  "/tirunelveli-cab-service",
  "/taxi-service-in-tirunelveli",
  "/taxi-services-in-nava-kailayam-temples",
  "/cab-services-in-nava-kailayam-temples",
  "/book-cab-in-nava-kailayam-temples",
  "/cab-service-from-tirunelveli-to-nava-kailayam-temples",
  "/taxi-services-from-tirunelveli-to-nava-kailayam-temples",
  "/cab-services-in-tirunelveli",
  "/tirunelveli-railway-station-taxi-cab-pickup",
  "/hotel-pickup-drop-cab-services-tirunelveli"
];

export const areaSeoRoutePaths = [
  "/cabs-tirunelveli-junction",
  "/cabs-palayamkottai-tirunelveli",
  "/cabs-nava-tirupathi-tirunelveli",
  "/cabs-thoothukudi-tirunelveli",
  "/cabs-tirunelveli-to-madurai",
  "/cabs-tirunelveli-to-chennai",
  "/cabs-tirunelveli-to-kanyakumari",
  "/cabs-tirunelveli-to-courtallam",
  "/airport-cab-tirunelveli",
  "/cabs-tirunelveli-to-coimbatore",
  "/cabs-tirunelveli-to-bangalore",
  "/cabs-tirunelveli-to-rameshwaram",
  "/cabs-tirunelveli-to-tiruchendur",
  "/cabs-tirunelveli-to-papanasam",
  "/cabs-tirunelveli-to-srivaikuntam",
  "/cabs-tirunelveli-to-ambasamudram",
  "/cabs-tirunelveli-to-nanguneri",
  "/cabs-tirunelveli-to-vikramasingapuram",
  "/cabs-tirunelveli-to-sankarankoil",
  "/cabs-tirunelveli-to-tenkasi",
  "/cabs-tirunelveli-to-thiruvananthapuram",
  "/cabs-tirunelveli-to-ooty",
  "/cabs-tirunelveli-to-kodaikanal",
  "/cabs-tirunelveli-to-dhanushkodi",
  "/local-cab-tirunelveli",
  "/cabs-tirunelveli-to-pothigai-hills",
  "/cabs-tirunelveli-to-alwar-tirunagari",
  "/long-distance-cab-tirunelveli",
  "/wedding-cab-tirunelveli",
  "/corporate-cab-tirunelveli",
  "/hospital-cab-tirunelveli",
  "/cabs-in-tirunelveli",
  "/call-taxi-in-tirunelveli",
  "/nava-tirupathi-in-tirunelveli",
  "/tempo-traveller-in-tirunelveli"
];

export const tirunelveliSeoRoutes = [
  "/cabs-in-palayamkottai",
  "/cabs-in-tirunelveli-junction",
  "/cabs-in-melapalayam",
  "/cabs-in-vannarpettai",
  "/cabs-in-sankar-nagar",
  "/cabs-in-pettai",
  "/cabs-in-krishnapuram",
  "/cabs-in-perumalpuram",
  "/cabs-in-palayankoil",
  "/cabs-in-ayikudy",
  "/cabs-in-manimuthar",
  "/cabs-in-radhapuram",
  "/cabs-in-nanguneri",
  "/cabs-in-kallidaikurichi",
  "/cabs-in-ambasamudram",
  "/cabs-in-tenkasi",
  "/cabs-in-sankarankoil",
  "/cabs-in-valliyoor",
  "/cabs-in-thisayanvilai",
  "/cabs-in-ilanji",
  "/cabs-in-tiruchendur",
  "/cabs-in-thoothukudi",
  "/cabs-in-nagercoil",
  "/cabs-in-kanyakumari",
  "/cabs-in-madurai",
  "/cabs-in-courtallam",
  "/cabs-in-rameswaram",
  "/cabs-in-chennai",
  "/cabs-in-trivandrum",
  "/cabs-in-ooty",
  "/cabs-in-bangalore",
  "/cabs-in-nava-tirupathi",
  "/cabs-in-srivaikuntam",
  "/cabs-in-tirunelveli-medical-college",
  "/cabs-in-thoothukudi-airport",
  "/cabs-in-madurai-airport",
  "/cabs-in-tempo-traveller-tirunelveli",
  "/cabs-in-innova-crysta-tirunelveli",
  "/call-taxi-in-palayamkottai",
  "/call-taxi-in-tirunelveli-junction",
  "/call-taxi-in-melapalayam",
  "/call-taxi-in-vannarpettai",
  "/call-taxi-in-sankar-nagar",
  "/call-taxi-in-pettai",
  "/call-taxi-in-krishnapuram",
  "/call-taxi-in-perumalpuram",
  "/call-taxi-in-palayankoil",
  "/call-taxi-in-ayikudy",
  "/call-taxi-in-manimuthar",
  "/call-taxi-in-radhapuram",
  "/call-taxi-in-nanguneri",
  "/call-taxi-in-kallidaikurichi",
  "/call-taxi-in-ambasamudram",
  "/call-taxi-in-tenkasi",
  "/call-taxi-in-sankarankoil",
  "/call-taxi-in-valliyoor",
  "/call-taxi-in-thisayanvilai",
  "/call-taxi-in-ilanji",
  "/call-taxi-in-tiruchendur",
  "/call-taxi-in-thoothukudi",
  "/call-taxi-in-nagercoil",
  "/call-taxi-in-kanyakumari",
  "/call-taxi-in-madurai",
  "/call-taxi-in-courtallam",
  "/call-taxi-in-rameswaram",
  "/call-taxi-in-chennai",
  "/call-taxi-in-trivandrum",
  "/call-taxi-in-ooty",
  "/call-taxi-in-bangalore",
  "/call-taxi-in-nava-tirupathi",
  "/call-taxi-in-srivaikuntam",
  "/call-taxi-in-tirunelveli-medical-college",
  "/call-taxi-in-thoothukudi-airport",
  "/call-taxi-in-madurai-airport",
  "/call-taxi-in-tempo-traveller-tirunelveli",
  "/call-taxi-in-innova-crysta-tirunelveli",
  "/taxi-in-palayamkottai",
  "/taxi-in-tirunelveli-junction",
  "/taxi-in-melapalayam",
  "/taxi-in-vannarpettai",
  "/taxi-in-sankar-nagar",
  "/taxi-in-pettai",
  "/taxi-in-krishnapuram",
  "/taxi-in-perumalpuram",
  "/taxi-in-palayankoil",
  "/taxi-in-ayikudy",
  "/taxi-in-manimuthar",
  "/taxi-in-radhapuram",
  "/taxi-in-nanguneri",
  "/taxi-in-kallidaikurichi",
  "/taxi-in-ambasamudram",
  "/taxi-in-tenkasi",
  "/taxi-in-sankarankoil",
  "/taxi-in-valliyoor",
  "/taxi-in-thisayanvilai",
  "/taxi-in-ilanji",
  "/taxi-in-tiruchendur",
  "/taxi-in-thoothukudi",
  "/taxi-in-nagercoil",
  "/taxi-in-kanyakumari",
  "/taxi-in-madurai",
  "/taxi-in-courtallam",
  "/taxi-in-rameswaram",
  "/taxi-in-chennai",
  "/taxi-in-trivandrum",
  "/taxi-in-ooty",
  "/taxi-in-bangalore",
  "/taxi-in-nava-tirupathi",
  "/taxi-in-srivaikuntam",
  "/taxi-in-tirunelveli-medical-college",
  "/taxi-in-thoothukudi-airport",
  "/taxi-in-madurai-airport",
  "/taxi-in-tempo-traveller-tirunelveli",
  "/taxi-in-innova-crysta-tirunelveli",
  "/car-rental-in-palayamkottai",
  "/car-rental-in-tirunelveli-junction",
  "/car-rental-in-melapalayam",
  "/car-rental-in-vannarpettai",
  "/car-rental-in-sankar-nagar",
  "/car-rental-in-pettai",
  "/car-rental-in-krishnapuram",
  "/car-rental-in-perumalpuram",
  "/car-rental-in-palayankoil",
  "/car-rental-in-ayikudy",
  "/car-rental-in-manimuthar",
  "/car-rental-in-radhapuram",
  "/car-rental-in-nanguneri",
  "/car-rental-in-kallidaikurichi",
  "/car-rental-in-ambasamudram",
  "/car-rental-in-tenkasi",
  "/car-rental-in-sankarankoil",
  "/car-rental-in-valliyoor",
  "/car-rental-in-thisayanvilai",
  "/car-rental-in-ilanji",
  "/car-rental-in-tiruchendur",
  "/car-rental-in-thoothukudi",
  "/car-rental-in-nagercoil",
  "/car-rental-in-kanyakumari",
  "/car-rental-in-madurai",
  "/car-rental-in-courtallam",
  "/car-rental-in-rameswaram",
  "/car-rental-in-chennai",
  "/car-rental-in-trivandrum",
  "/car-rental-in-ooty",
  "/car-rental-in-bangalore",
  "/car-rental-in-nava-tirupathi",
  "/car-rental-in-srivaikuntam",
  "/car-rental-in-tirunelveli-medical-college",
  "/car-rental-in-thoothukudi-airport",
  "/car-rental-in-madurai-airport",
  "/car-rental-in-tempo-traveller-tirunelveli",
  "/car-rental-in-innova-crysta-tirunelveli",
  "/tempo-traveller-in-palayamkottai",
  "/tempo-traveller-in-tirunelveli-junction",
  "/tempo-traveller-in-melapalayam",
  "/tempo-traveller-in-vannarpettai",
  "/tempo-traveller-in-sankar-nagar",
  "/tempo-traveller-in-pettai",
  "/tempo-traveller-in-krishnapuram",
  "/tempo-traveller-in-perumalpuram",
  "/tempo-traveller-in-palayankoil",
  "/tempo-traveller-in-ayikudy",
  "/tempo-traveller-in-manimuthar",
  "/tempo-traveller-in-radhapuram",
  "/tempo-traveller-in-nanguneri",
  "/tempo-traveller-in-kallidaikurichi",
  "/tempo-traveller-in-ambasamudram",
  "/tempo-traveller-in-tenkasi",
  "/tempo-traveller-in-sankarankoil",
  "/tempo-traveller-in-valliyoor",
  "/tempo-traveller-in-thisayanvilai",
  "/tempo-traveller-in-ilanji",
  "/tempo-traveller-in-tiruchendur",
  "/tempo-traveller-in-thoothukudi",
  "/tempo-traveller-in-nagercoil",
  "/tempo-traveller-in-kanyakumari",
  "/tempo-traveller-in-madurai",
  "/tempo-traveller-in-courtallam",
  "/tempo-traveller-in-rameswaram",
  "/tempo-traveller-in-chennai",
  "/tempo-traveller-in-trivandrum",
  "/tempo-traveller-in-ooty",
  "/tempo-traveller-in-bangalore",
  "/tempo-traveller-in-nava-tirupathi",
  "/tempo-traveller-in-srivaikuntam",
  "/tempo-traveller-in-tirunelveli-medical-college",
  "/tempo-traveller-in-thoothukudi-airport",
  "/tempo-traveller-in-madurai-airport",
  "/tempo-traveller-in-tempo-traveller-tirunelveli",
  "/tempo-traveller-in-innova-crysta-tirunelveli"
];
